export default __webpack_public_path__ + "images/1D.27b6cba.png";